import { render, staticRenderFns } from "./RegistrationStepper.vue?vue&type=template&id=f86ae5ae&"
import script from "./RegistrationStepper.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepper.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepper.vue?vue&type=style&index=0&id=f86ae5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports